
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule, SystemModule } from "@/store/modules/";
import * as modals from "@/lib/modals";
import { AddOrderPalletRequest } from "@/models/api/orders/orderPallet";

const systemModule = getModule(SystemModule);
const orderModule = getModule(OrderModule);

@Component({
  name: modals.addOrderPalletsModal
})
export default class AddOrderPalletsModal extends Mixins(mixin) {
  palletIds: string;
  saving: boolean = false;

  @Ref() readonly orderPalletIds!: HTMLInputElement;

  created() {
    this.palletIds = "";
  }

  resetModal() {
    this.palletIds = "";
  }

  onShown() {
    this.show();
    this.orderPalletIds.focus();
  }

  async saveOrderPallets() {
    this.saving = true;

    let palletIdArray = this.palletIds.split(/\r?\n/);
  
    if(palletIdArray)
    {
      for (let index = 0; index < this.selectedItems.length; index++) {      
        const selectedOrder = this.selectedItems[index];
        
        for (let palletIndex = 0; palletIndex < palletIdArray.length; palletIndex++){       
          const palletId = palletIdArray[palletIndex];
          if(palletId  && palletId.trim() != "")
          {

            let request : AddOrderPalletRequest = {
              orderHeaderNumber : selectedOrder.headerNumber,
              palletId : palletId
            };

            let action = orderModule.addOrderPallet;

            try {
              let data = await action(request);
              
              if (!data.isWarning){
                this.addActionResult(
                {
                  number: selectedOrder.headerNumber + ((palletIndex + 1) * .001),
                  success: true,
                  message: `Pallet ${request.palletId} added to order ${request.orderHeaderNumber}.`
                });
              }
              else {
                this.addActionResult(
                {
                  number: selectedOrder.headerNumber + ((palletIndex + 1) * .001),
                  success: true,
                  warning: true,
                  message: `Pallet ${request.palletId} added to order ${request.orderHeaderNumber}. ${data.message}`
                });
              }
            } catch  (error) {
              this.addActionResult(
              {
                number: selectedOrder.headerNumber + ((palletIndex + 1) * .001),
                success: false,
                message: `Failed to add pallet ${request.palletId} added to order ${request.orderHeaderNumber}. ${error.response.data.message}`,
                error: error.response.data && error.response.data.errors ? error.response.data.errors : null,
                errorMessages: error.response.data && error.response.data.errorMessages ? error.response.data.errorMessages : null
              });
            }
          }
        }
      }
    }
  
    this.saving = false;
    this.hideModal();
  }
}
